import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { getPmsDashboardPath, isUsaPmsEnvironment } from '../utils/pms-dashboard-path.util';

export const pmsDashboardRedirectGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  const url = state.url.split('?')[0];

  if (url === '/dashboard' && isUsaPmsEnvironment()) {
    router.navigate([getPmsDashboardPath()]);
    return false;
  }

  if (url.startsWith('/us/dashboard') && !isUsaPmsEnvironment()) {
    router.navigate([getPmsDashboardPath()]);
    return false;
  }

  return true;
};
